<template>
	<!-- <Transition name="modal-fade"> -->
		<div class="modal-backdrop" @click="onBackdropClick">
			<div class="modal"
				ref="modal"
				role="dialog"
				aria-labelledby="modalTitle"
				aria-describedby="modalDescription"
			>
				<header
					class="modal-header"
					id="modalTitle"
				>
					<slot name="header" :close="close"></slot>
				</header>

				<section
					class="modal-body"
					id="modalDescription"
				>
					<slot name="body" :close="close"></slot>
				</section>

				<footer class="modal-footer">
					<slot name="footer" :close="close"></slot>
				</footer>
			</div>
		</div>
	<!-- </Transition> -->
</template>

<script>
export default {
  name  : 'base-modal',
  props : {
    value : Boolean
  },
  methods : {
    close() {
      this.$emit( 'input', false );
    },
    onBackdropClick( e ) {
      // BUG(Johnny): I believe this is causing an error when we close the modal. e.target.className.includes is undefined.
	  // Check if the backdrop was clicked, and not the modal itself
      if ( e.target.className.includes( 'modal-backdrop' ) ) this.$emit( 'backdropClick' );
    }
  },
};
</script>

<style lang="scss" scoped>
// Animates such that the backdrop fades in and the modal content slides in from the bottom
// .modal-fade-enter,
// .modal-fade-leave-to {
//     opacity: 0;

//     & .modal {
//         transform: translateY(50vh);
//     }
// }

// .modal-fade-enter-active,
// .modal-fade-leave-active {
//     transition: opacity 0.5s ease;

//     & .modal {
//         transition: transform 0.5s ease;
//     }
// }

.modal-backdrop {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(226, 231, 234, 0.8);
	display: flex;
	justify-content: center;
	align-items: center;
}

.modal {
	position: relative;
	background: #FFFFFF;
	// box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1), 0px 1px 4px rgba(0, 0, 0, 0.2);
	box-shadow: $floatingObject;
	border-radius: 10px;
	overflow-x: auto;
	display: flex;
	flex-direction: column;

	.modal-header {
		position: relative;
		background-color: $primary;
		color: white;
		font-weight: 600;
		font-size: 18px;
	}

	.modal-body {
		position: relative;
	}

	.modal-footer {
		position: relative;
	}
}


.btn-close {
	position: absolute;
	top: 0;
	right: 0;
	border: none;
	font-size: 20px;
	padding: 10px;
	cursor: pointer;
	font-weight: bold;
	color: #4AAE9B;
	background: transparent;
}

.btn-green {
	color: white;
	background: #4AAE9B;
	border: 1px solid #4AAE9B;
	border-radius: 2px;
}
</style>
